module.exports = __webpack_public_path__ + "static/media/videotape.1197be10.png";